<app-protocolo-envio
    [titulo]="titulo"
    [instrucoesEnvio]="instrucoesEnvio"
    [routerLinkPesquisaLote]="['/recuperacoes-credito/lote']"
    [tipoConteudoArquivo]="tipoConteudoArquivo"
    [textoBtnArquivoExemplo]="textoBtnArquivoExemplo"
    [tipoArquivoExemplo]="tipoArquivoExemplo"
>
</app-protocolo-envio>


